import * as React from 'react'

type CheckBox = {
  isChecked: boolean
  handleChange?: () => void
}

export const CheckBox: React.FC<CheckBox> = ({ isChecked, handleChange }) => {
  return (
    <input
      checked={isChecked}
      onChange={handleChange}
      id="checked-checkbox"
      type="checkbox"
      value=""
      className="h-4 w-4 rounded border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500"
    />
  )
}
